import styled from 'styled-components';
import { LiveScoring } from './LiveScoring';

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  padding: 0 1rem;
`;

export type SideBarProps = {
  children?: React.ReactNode;
};

export const SideBar: React.FC<SideBarProps> = () => {
  return (
    <Flex>
      <LiveScoring />
    </Flex>
  );
};
